export const SET_LOADING = 'SET_LOADING';

export const SET_PROJECT = 'SET_PROJECT';

export const UPDATE_PROJECT = 'UPDATE_PROJECT';

export const SELECT_ALL_TENANT_PROD = 'SELECT_ALL_TENANT_PROD';

export const SELECT_ALL_TENANT_TEST = 'SELECT_ALL_TENANT_TEST';

export const SELECT_TENANT_PROD = 'SELECT_TENANT_PROD';

export const SELECT_TENANT_TEST = 'SELECT_TENANT_TEST';

export const SET_TENANTS = 'SET_TENANTS';

export const DELETE_TENANT = 'DELETE_TENANT';

export const DISABLE_TENANT = 'DISABLE_TENANT';

export const ENABLE_TENANT = 'ENABLE_TENANT';

export const DELETE_TENANT_INSTANCE = 'DELETE_TENANT_INSTANCE';

export const DISABLE_TENANT_INSTANCE = 'DISABLE_TENANT_INSTANCE';

export const ENABLE_TENANT_INSTANCE = 'ENABLE_TENANT_INSTANCE';

export const SET_TENANT_ID = 'SET_TENANT_ID';

export const SELECT_TENANT_ID = 'SELECT_TENANT_ID';

export const DESELECT_TENANT_ID = 'DESELECT_TENANT_ID';

export const SET_INSTANCE_ID = 'SET_INSTANCE_ID';

export const SELECT_ALL_TENANT_IDS = 'SELECT_ALL_TENANT_IDS';

export const DESELECT_ALL_TENANT_IDS = 'DESELECT_ALL_TENANT_IDS';

export const TOGGLE_DELETE_APP_DIALOG = 'TOGGLE_DELETE_APP_DIALOG';

export const TOGGLE_DELETE_APP_INSTANCE_DIALOG = 'TOGGLE_DELETE_APP_INSTANCE_DIALOG';

export const TOGGLE_DISABLE_APP_INSTANCE_DIALOG = 'TOGGLE_DISABLE_APP_INSTANCE_DIALOG';

export const TOGGLE_DISABLE_APP_DIALOG = 'TOGGLE_DISABLE_APP_DIALOG';

export const TOGGLE_SYNC_ALL_TENANTS_DIALOG = 'TOGGLE_SYNC_ALL_TENANTS_DIALOG';

export const TOGGLE_SYNC_TENANT_DIALOG = 'TOGGLE_SYNC_TENANT_DIALOG';

export const UPDATE_ALL_TENANTS = 'UPDATE_ALL_TENANTS';

export const UPDATE_TENANT_BY_TENANT_ID = 'UPDATE_TENANT_BY_TENANT_ID';

export const SET_ERROR = 'SET_ERROR';
